
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"45","height":"31","rx":"5.5","fill":"#fff","stroke":"#EEE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.26 23.175a8.8 8.8 0 01-5.818 2.198c-4.953 0-8.968-4.12-8.968-9.204 0-5.083 4.015-9.204 8.968-9.204 2.22 0 4.251.828 5.817 2.199a8.8 8.8 0 015.818-2.199c4.953 0 8.968 4.121 8.968 9.204 0 5.084-4.015 9.204-8.968 9.204a8.8 8.8 0 01-5.818-2.198z","fill":"#ED0006"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.26 23.175a9.284 9.284 0 003.15-7.006 9.284 9.284 0 00-3.15-7.005 8.8 8.8 0 015.817-2.199c4.953 0 8.968 4.121 8.968 9.204 0 5.084-4.015 9.204-8.968 9.204a8.8 8.8 0 01-5.818-2.198z","fill":"#F9A000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.26 9.164a9.284 9.284 0 013.15 7.005 9.284 9.284 0 01-3.15 7.005 9.284 9.284 0 01-3.152-7.005 9.284 9.284 0 013.151-7.005z","fill":"#FF5E00"}})])
          )
        }
      }
    